var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFacebook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 1400 1400",
    width: "48px",
    height: "48px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#000000",
    cx: "50%",
    cy: "50%",
    r: "50%"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(450, 150)",
    d: "M130.702 1053.42V559.124H0V381.154H130.702V229.145C130.702 109.694 207.908 0 385.807 0C457.835 0 511.097 6.90515 511.097 6.90515L506.9 173.099C506.9 173.099 452.582 172.57 393.307 172.57C329.154 172.57 318.876 202.134 318.876 251.203V381.154H512L503.597 559.124H318.876V1053.42H130.702Z",
    x: 500,
    y: 500,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook.aa74ae30.svg";
export { ForwardRef as ReactComponent };